<template>
  <div class="whitedark-bg">
    <div class="wrapper" :style="screenWidth>768?'':'padding-left: 50px; padding-right: 50px;'">
      <div class="more-works-title black fw-600 serif">More Works</div>
      <el-row :gutter="80">
        <el-col v-for="(n,idx) in worksList" v-show="idx<2" :key="idx" :span="12" :xs="24">
          <div @click="viewItem(n)" class="more-works-item pr lf-0">
            <div v-observe-visibility="visibilityChanged" :class="screenWidth>1200?'transition-wrap':''" class="graylight-bg pr ht-100x">
              <div
                style="height:50%;"
                :style="{backgroundImage: 'url(' + n.work_poster + ')'}"
                class="wi-100x silverdark-bg centerimage transition-slow pa bm-0 lf-0"></div>
            </div>
            <div class="dis-ib pa lf--30 more-works-item-title-box">
              <div class="more-works-item-title serif">{{n.work_title}}</div>
              <div class="more-works-item-tags op-8 cur-p">
                <span>{{n.work_subtitle}}</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'moreWorks',
  computed: {
    ...mapGetters([
      'scrollHeight',
      'screenWidth'
    ])
  },
  data () {
    return {
      worksList: []
    }
  },
  mounted () {
    // 如果缓存有数据就在缓存取
    if (this.$.g('worksList') === '' || this.$.g('worksList') === undefined || this.$.g('worksList') === null) {
      this.readHotWorks()
    } else {
      // 过滤当前文章
      this.worksList = this.$.s2o(this.$.g('worksList')).filter(item => item.id !== this.$route.params.id * 1)
    }
  },
  methods: {
    /*
    * 查询作品
    */
    readHotWorks () {
      this.worksList = []
      this.get({
        url: 'webWorksRead',
        data: {
          work_team_id: '6',
          work_status: 2
        }
      }, (r) => {
        if (r.code) {
          this.$.s('worksList', this.$.o2s(r.data.items))
          // 过滤当前文章
          this.worksList = r.data.items.filter(item => item.id !== this.$route.params.id * 1)
        }
      })
    },
    /**
      * 查看详情
      */
    viewItem (val) {
      let routeUrl = this.$router.resolve({
        path: '/works/' + val.id
      })
      window.open(routeUrl.href, '_blank')
    },
    /**
    * 封面图片
    */
    visibilityChanged (isVisible, entry) {
      if (isVisible) {
        entry.target.firstElementChild.style.height = '100%'
      }
    }
  }
}
</script>
<style>
.more-works-item-title {
  font-size: 1.375em;
  font-weight: 600;
  margin-bottom: 0;
}
.more-works-title {
  font-size: 2em;
  padding-top: 50px;
  padding-bottom: 50px;
}
.more-works-item {
  height: 25em;
  margin-bottom: 4em;
}
.more-works-item-title-box {
  bottom: 1.5em;
}
.more-works-item-tags {
  font-size: 0.875em;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .more-works-item-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .more-works-item {
    height: 400px;
    margin-bottom: 115px;
  }
  .more-works-title {
    font-size: 52px;
    padding-top: 100px;
    padding-bottom: 80px;
  }
  .more-works-item-title-box {
    bottom: 28px;
  }
  .more-works-item-tags {
    font-size: 15px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .more-works-item-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .more-works-title {
    font-size: 56px;
    padding-top: 100px;
    padding-bottom: 80px;
  }
  .more-works-item {
    height: 500px;
    margin-bottom: 130px;
  }
  .more-works-item-title-box {
    bottom: 40px;
  }
  .more-works-item-tags {
    font-size: 15px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .more-works-item-title {
    font-size: 38px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .more-works-title {
    font-size: 60px;
    padding-top: 100px;
    padding-bottom: 80px;
  }
  .more-works-item {
    height: 600px;
    margin-bottom: 145px;
  }
  .more-works-item-title-box {
    bottom: 50px;
  }
  .more-works-item-tags {
    font-size: 16px;
  }
}
@media screen and (min-width: 1920px) {
  .more-works-item-title {
    font-size: 46px;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .more-works-title {
    font-size: 64px;
    padding-top: 100px;
    padding-bottom: 80px;
  }
  .more-works-item {
    height: 700px;
    margin-bottom: 160px;
  }
  .more-works-item-title-box {
    bottom: 60px;
  }
  .more-works-item-tags {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/moreWorks.vue